
<div class="dropzone-wrapper" [disabled]="disabled" appDnd (fileDropped)="onFileDropped($event)">
  <div class="drop-area">
    <div class="text-wrapper">
      <div class="upload-icon upload-icon-cloud"></div>
      <div class="text visible-lg">Trascina i file qui <br> <b>o</b> <br></div>
      <div class="upload-btn-wrapper target-btn" id="target_{{randomId}}">
        <input aria-label="Seleziona file" [disabled]="disabled" #fileUploader (focus)="onFocus($event)" type="file" id="input-uploader" name="myfile" (change)="fileBrowseHandler($event)"
        style="cursor: pointer;" [multiple]="multiple" />
        <button [disabled]="disabled" [ngClass]="onFocusFlag ? 'focus-element': ''" class="btn btn-primary btn-block dropzone-btn visible-lg select-file" tabindex="2" aria-label="seleziona file" style="cursor: pointer">Seleziona file</button>
        <button [disabled]="disabled" [ngClass]="onFocusFlag ? 'focus-element': ''" class="btn btn-primary btn-block dropzone-btn visible-xs visible-sm visible-md" tabindex="2" aria-label="carica documento" style="cursor: pointer">Carica documento</button>
      </div>
    </div>
  </div>
</div>

